document.addEventListener('DOMContentLoaded', () => {
    const floatingMenu = document.getElementById('floating-social-menu');
    let scrollThreshold = 0;

    window.addEventListener('scroll', () => {
        // Obtém a quantidade de scroll atual
        const scrolled = window.scrollY || document.documentElement.scrollTop;
        const triggerHeight = window.innerHeight / 3; // Ajusta o gatilho para metade da altura da janela

        // Incrementa o contador ao passar múltiplos da altura definida
        if (scrolled > triggerHeight * (scrollThreshold + 1)) {
            scrollThreshold++;
        } else if (scrolled < triggerHeight * scrollThreshold && scrollThreshold > 0) {
            // Decrementa o contador ao voltar acima do limite
            scrollThreshold--;
        }

        // Controla a visibilidade do menu pelo ID
        if (scrollThreshold >= 1) {
            floatingMenu.style.opacity = '1';
            floatingMenu.style.visibility = 'visible';
        } else {
            floatingMenu.style.opacity = '0';
            floatingMenu.style.visibility = 'hidden';
        }
    });
});

